import { useNavigate } from "react-router-dom";
import Header from "../../../../components/common/header";
import { HiOutlineChevronRight } from "react-icons/hi2";
import { useState } from "react";
import { gql, useQuery } from "@apollo/client";
import { NoticeModal } from "../../components/notice-modal";
import { Notice } from "../../../../__generated__/graphql";

const GET_NOTICES = gql`
  query getNotices {
    notices {
      id
      title
      pageUrl
      isDeleted
      createdAt
      updatedAt
    }
  }
`;

const BossNotice = () => {
  const navigate = useNavigate();
  const [isNoticeModalOpen, setIsNoticeModalOpen] = useState(false);
  const [popupContent, setPopupContent] = useState({ title: "", src: "" });

  const { data: noticesData } = useQuery(GET_NOTICES, {
    fetchPolicy: "cache-and-network",
  });

  const handleMenuClick = (item: Notice) => {
    setPopupContent({ title: item.title, src: item.pageUrl || "" });
    setIsNoticeModalOpen(true);
  };

  return (
    <div className="flex flex-col h-screen bg-white">
      <Header title="사장님 공지사항" showBackButton />

      <div className="flex-1 overflow-y-auto px-4 py-4">
        <div className="space-y-4">
          {noticesData?.notices?.map((notice: Notice) => (
            <div key={notice.id}>
              <div
                className="flex items-center justify-between cursor-pointer py-4 px-1 bg-white border-b border-gray-300"
                onClick={() => handleMenuClick(notice)}
              >
                <div className="flex-1">
                  <div className="flex items-center gap-3 mb-1">
                    <span className="text-md text-gray-500">
                      {new Date(notice.createdAt).toLocaleDateString("ko-KR", {
                        year: "numeric",
                        month: "2-digit",
                        day: "2-digit",
                      })}
                    </span>
                  </div>
                  <p className="text-xl font-semibold text-gray-800">
                    {notice.title}
                  </p>
                </div>
                <HiOutlineChevronRight className="w-6 h-6 text-gray-400 flex-shrink-0 ml-4" />
              </div>
            </div>
          ))}
        </div>
      </div>

      <div className="px-4 py-4 bg-gray-50">
        <div
          className="w-full bg-primary text-white px-4 py-4 rounded-xl transition-shadow cursor-pointer"
          onClick={() => {
            navigate("/boss/onboarding/sales-overview");
          }}
        >
          <div className="flex items-center justify-between">
            <div className="text-xl font-semibold">
              판매방식에 대해 다시 알아볼까요?
            </div>
            <HiOutlineChevronRight className="w-5 h-5" />
          </div>
        </div>
      </div>

      <NoticeModal
        isOpen={isNoticeModalOpen}
        onClose={() => setIsNoticeModalOpen(false)}
        src={popupContent.src}
        title={popupContent.title}
      />
    </div>
  );
};

export default BossNotice;
